import { Flex } from '@mantine/core';
import { ReactNode, RefObject } from 'react';

export const ReportHistoryCarousel = ({
  children,
  ref,
  onMouseEnter,
  onMouseDown,
  onTouchStart,
}: {
  children: ReactNode;
  ref?: RefObject<HTMLDivElement | null>;
  onMouseEnter?: () => void;
  onMouseDown?: () => void;
  onTouchStart?: () => void;
}) => {
  return (
    <Flex
      ref={ref}
      direction={'row'}
      gap={'var(--mantine-spacing-md)'}
      style={{
        width: '100%',
        overflow: 'scroll',
        scrollSnapType: 'inline mandatory',
        scrollbarWidth: 'none',
        padding: 'var(--mantine-spacing-md)',
      }}
      onMouseEnter={onMouseEnter}
      onMouseDown={onMouseDown}
      onTouchStart={onTouchStart}
    >
      {children}
    </Flex>
  );
};
